export const categories = [
    "Art",
    "Collectibles",
    "Photography",
    "AR",
    "VR",
    "Interactive",
];